import { Button, Stack, Typography } from '@montugroup/design-system';
import { styled } from '@mui/material';

export const Paragraph = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(6),
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  padding: `${theme.spacing(3)} !important`,

  [theme.breakpoints.up('sm')]: {
    padding: `${theme.spacing(4)} !important`,
  },
}));

export const ButtonsContainer = styled(Stack)(({ theme }) => ({
  position: 'fixed',
  left: 0,
  right: 0,
  bottom: 0,
  padding: theme.spacing(4, 6),
  gap: theme.spacing(3),
  backgroundColor: theme.palette.background.paper,

  [theme.breakpoints.up('sm')]: {
    position: 'relative',
    padding: 0,
    gap: theme.spacing(4),
    backgroundColor: 'transparent',
  },
}));
